module.exports = __webpack_public_path__ + "img/os.3c3cc959.png";